import React from 'react';
import '../styles/theme.css';
import '../styles/Login.css';
import BruteHeader from '../components/BruteHeader';
import BruteFooter from '../components/BruteFooter';
import LoginAccessPanel from '../components/LoginAccessPanel';
import { authService } from '../services/authService';
import { useAuth } from '../context/AuthContext';

function LoginPage() {
  const { login } = useAuth();

  const verifyIdentity = async ({ identity, credential }) => {
    try {
      const res = await authService.login({ username: identity, password: credential });
      login(res.username, res.access_token, res.role);
      return { ok: true, redirectTo: res.redirect_to };
    } catch (err) {
      return { ok: false, error: err.message };
    }
  };

  return (
    <div className="lo-root">
      <div className="lo-layout-1">
        <div id="loginheaderslot" className="lo-slot-loginheaderslot">
          <BruteHeader activePage={"Login"} />
        </div>
        <div className="lo-layout-2">
          <div id="loginaccesspanel" className="lo-slot-loginaccesspanel">
            <LoginAccessPanel onVerifyIdentity={verifyIdentity} />
          </div>
        </div>
        <div id="loginfooterslot" className="lo-slot-loginfooterslot">
          <BruteFooter />
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
